import {
  PapiDaSharedTierCreate,
  PapiRequestDaSharedTierCreate,
} from '@wix/da-papi-types';
import i18next from 'i18next';
import { all, take, call, put, takeEvery } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client';
import { actions as modalActions } from '../../../Modals';
import { ModalType } from '../../../Modals/redux/types';
import { reduxModuleLoaded, createTipJarTier } from './actions';

let TIP_JAR_COVER_DEVIATION_ID = 902857689;
if (process.env.NODE_ENV !== 'production') {
  TIP_JAR_COVER_DEVIATION_ID = 436618228;
}

function* handleCreateTipJarTier() {
  const data: PapiRequestDaSharedTierCreate = {
    title: i18next.t('tierPopup.tipJar.title'),
    description: i18next.t('tierPopup.tipJar.description'),
    price: 2,
    display_num_subscribers: false,
    benefits: [
      i18next.t('tierPopup.tipJar.firstBenefit'),
      i18next.t('tierPopup.tipJar.secondBenefit'),
    ],
    tags: ['tipjar', 'tip'],
    access_settings: 'all',
    thank_message_title: i18next.t('tierPopup.tipJar.thanks.title'),
    thank_message_body: i18next.t('tierPopup.tipJar.thanks.body'),
    cover_image_deviation_id: TIP_JAR_COVER_DEVIATION_ID,
    is_mature: false,
  };

  const response: PapiDaSharedTierCreate = yield call(requestPuppy, {
    method: 'post',
    url: '/tier/create',
    data,
  });

  yield put(
    modalActions.pushModal(ModalType.TIER_EDIT, {
      wrapInModal: false,
      params: response,
    })
  );
}

export default function* userTiersSaga() {
  yield take(reduxModuleLoaded);
  yield all([takeEvery(createTipJarTier, handleCreateTipJarTier)]);
}
